<template>
  <div class="live">
    <div class="live">
      <div class="title">{{ $t('homePage.live.title') }}</div>
      <div class="exhibitorsLive">
        <!-- 轮播开始 -->

        <!-- swiper -->
        <div v-for="(item, index) in lunItem" :key="index" class="swiper_slide">
          <div class="card" @click="goDetail(item)">
            <div class="backImg">
              <img :src="item.backImgUrl" alt="" class="fengmian" v-if="item.backImgUrl.substr(0,4)=='http'"/>
              <img :src="baseUrl + item.backImgUrl" alt="" class="fengmian" v-else/>
              <span class="bottomImg" @click.stop="collection(item, 3)">
                <img v-if="item.collectStatus" alt="" src="../../../static/collent_yello.png" /><!--显示金色-->
                <img v-else alt="" src="../../../static/collent.png" /><!--显示无色-->
              </span>
              <!-- <div class="fixed">
                <div class="banner-btn">
                  <img alt="" src="../../../static/ico_vedio.png" />
                </div>
              </div> -->
            </div>

            <div class="liveInfo">
              <div class="text">{{ item.videoTitle }}</div>

              <div class="date">
                <div class="img">
                  <img alt="" src="../../../static/ico_time.png" />
                </div>
                <span>{{ item.date }}{{ $t('common.mobileLive') }}</span>
              </div>
            </div>

            <div class="company">{{ item.company }}</div>
          </div>
        </div>

        <!-- 分页 -->
        <div v-if="lunItem.length > 4" slot="pagination" class="swiper-pag"></div>

        <!-- 轮播结束 -->
      </div>

      <!--查看更多-->
      <router-link to="live">
        <div class="lookMore">{{ $t('common.viewMore') }}</div>
      </router-link>
    </div>

    <div class="alert_mess" v-show="qrShow">
      <img class="close" @click="closeQr" src="../../../static/close.png" />
      <div class="qrcode">
        <img :src="qrcode" alt="" />
      </div>
      <div class="tip">{{ $t('live.tip') }}</div>
    </div>
  </div>
</template>

<script>
import { getexhibitionLive } from '../../../../api/homePage';
import { forMat } from '../../../../utils/common';

export default {
  name: 'exhibitorsLive',
  data() {
    return {
      //轮播子元素
      lunItem: [],
      //收藏按钮
      collent_toggle: false,
      //弹窗二维码
      qrcode: null,
      qrShow: false,
      baseUrl: forMat()
    };
  },
  methods: {
    async getexhibitionLive() {
      try {
        let { data } = await getexhibitionLive();
        const arr = data.data.list.slice(0, 4);
        arr.forEach((item, i) => {
          this.lunItem.push({
            backImgUrl:item.coverPhoto,
            videoTitle: item.liveCn,
            date: item.startDate,
            company: item.exhibitorNameCn,
            id: item.id,
            videoAddress: `${item.videoAddress.substr(0,4)=='http'?'':baseUrl}${item.videoAddress}`, //二位码也存在此字段里
            videoType: item.videoType, //视频类型1=上传视频2=直播外链3=直播入口二维码
            collectStatus: item.collectStatus,
          });
        });
      } catch (e) {
        console.log(e);
      }
    },

    //使用父组件收藏方法
    collection(item, type) {
      this.$parent.collection(item, type);
    },

    //跳转至详情
    goDetail(item) {
      // 3=直播入口二维码
      item.videoType == 3 && (this.qrcode = item.videoAddress) && (this.qrShow = true);
      if (item.videoType == 1 || item.videoType == 2) {
        this.$router.push({
          name: 'live_detail',
          query: {
            userId: item.id,
          },
        });
      }
    },

    closeQr() {
      this.qrcode = null;
      this.qrShow = false;
    },
  },
  mounted() {
    this.getexhibitionLive();
    // console.log('test',this.lunItem.length);
  },
};
</script>
<style lang="scss" scoped>
.live {
  width: 100%;
  height: fit-content;
  background-color: #f6f6f7;
  //	border: 1px solid red;
  height: fit-content;
  padding-bottom: 1px;

  .title {
    font-size: 4.8vw;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    text-align: center;
    padding-top: 7.87vw;
    padding-bottom: 6.93vw;
    box-sizing: border-box;
  }

  .exhibitorsLive {
    width: 100%; //加6*4px是因为轮播内容要有左边距才能在移入时左侧显示出阴影
    margin: 0 auto;
    padding: 4vw 4vw 4vw 4vw;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .swiper_slide {
      width: 49%;
      margin-top: 4vw;
      .card {
        background-color: white;
        cursor: pointer;
        margin: 0 0.4vw; //外边距加 0.4vw显示卡片阴影
        transition: all 0.3s;

        &:hover {
          box-shadow: 0px 0px 0.4vw #9fa3a5;

          .backImg .fixed {
            visibility: visible;
            opacity: 1;
          }

          .text {
            color: #006fb8;
          }
        }

        .backImg {
          box-sizing: border-box;
          width: 100%;
          height: 26.7vw;
          position: relative;
          .fengmian {
            width: 100%;
            height: 100%;
          }

          .bottomImg {
            position: absolute;
            z-index: 99;
            right: 1.6vw;
            top: 1.6vw;
            width: 6vw;
            height: 6vw;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .fixed {
            width: 39.3vw;
            height: 25.3vw;
            position: absolute;
            top: 0;
            background-color: rgba(30, 30, 30, 0.3);
            //display: none;
            visibility: hidden;
            opacity: 0;
            z-index: 99;
            transition: opacity 0.3s;

            img {
              margin: 9.47vw 16.4vw;
            }
          }
        }
        .liveInfo {
          height: 20.53vw;
          padding: 2.6vw;
          box-sizing: border-box;
          .text {
            width: 37.7vw;
            font-size: 3.7vw;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 4.8vw;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            height: 9vw;
          }

          .date {
            margin: 0 auto;
            margin-top: 4vw;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            line-height: 3vw;
            color: #666;
            font-family: Microsoft YaHei;
            font-weight: 400;
            .img {
              width: 3vw;
              height: 3vw;

              img {
                width: 3vw;
                height: 3vw;
              }
            }

            span {
              margin-left: 1.6vw;
              font-size: 3vw;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666;
              line-height: 3vw;
              height: 3vw;
            }
          }
        }

        .company {
          margin: 0 auto;
          padding: 0px 3.7vw;
          border-top: 1px solid #e0e0e0;
          height: 9.3vw;
          // margin-top: 2.5vw;
          font-size: 2.6vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          line-height: 9.3vw;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }

  a {
    display: block;
    text-decoration: none;

    .lookMore {
      width: 48vw;
      height: 9.6vw;
      border: 1px solid #333333;
      border-radius: 1vw;
      margin: 0 auto;
      text-align: center;
      line-height: 4.3vw;
      margin-top: 6.6vw;
      color: #333333;
      font-size: 4.3vw;
      padding-top: 2.6vw;
      padding-bottom: 2.6vw;
      box-sizing: border-box;
      margin-bottom: 10.67vw;
      font-family: Microsoft YaHei;
    }
  }

  .alert_mess {
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    text-align: center;
    background: white;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    margin: auto;
    z-index: 999;
    justify-content: center;
    align-items: center;
    padding: 4vw;
    padding-top: 20vw;
    display: flex;
    .close {
      width: 3.2vw !important;
      height: 3.2vw !important;
      position: absolute;
      right: 10vw;
      top: 20vw;
      float: right;
    }

    .qrcode {
      justify-content: center;
      align-items: center;
      display: flex;
      margin: 0 auto;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      -webkit-transform: translate3d(-50%, -50%, 0);
      img {
        width: auto;
        height: auto;
        max-width: 90%;
        max-height: 90%;
      }
    }
    .tip {
      font-size: 4.3vw;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      position: absolute;
      bottom: 30vw;
    }
  }
}
</style>
